import React, { createContext, useContext, useState, useEffect } from 'react';
import { SiteConfig } from '../../System/SiteConfig';
import { unescapeArray, unescapeNested } from './unescapeArray';
import { getRecords, sendVerification } from '../Api/OPEXAPI';
const GlobalContext = createContext();

export const useGlobal = () => {
    return useContext(GlobalContext);
};

export const GlobalProvider = ({ children }) => {
    const [title, setTitle] = useState('Opex');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [ UserData, setUserData ] = useState({})
    const [ masterMenu, setMasterMenu ] = useState(localStorage.getItem(`${SiteConfig}-menu`) || "User")

    useEffect(() => {

        ( async () => {

            // When arriving via /auto/:userKey (log in as client user from main app), use userKey from URL not localStorage
            const pathMatch = window.location.pathname.match(/^\/auto\/([^/]+)/);
            const userKeyFromUrl = pathMatch ? pathMatch[1] : null;
            const userKeyToUse = userKeyFromUrl || localStorage.getItem(`${SiteConfig.cookieName}-cluId`);
            
        
            if (userKeyToUse) {

                let users = await getRecords(`SELECT * FROM users WHERE userKey = ?`, [ userKeyToUse ])

                

                if (users.length > 0) {

                    setData(users[0])
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                }

                
            }
            
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setData = async (user) => {

        setUserData(user);
        
        localStorage.setItem(`${SiteConfig.cookieName}-cluId`, user.userKey);

    }

    const getCode = async (username) => {
        
        let query = `SELECT users.*, clients.type FROM users LEFT OUTER JOIN clients ON users.clientKey = clients.clientKey WHERE users.email = ? AND clients.type = ?`
        let users = await getRecords(query, [ username, 'User' ])
        
        
        // users = unescapeArray(users);
        users = unescapeNested(users)

        console.log('users', users)

        if (users.length > 0) {

            // Generate a random 6-digit number for user verification
            const verificationCode = Math.floor(100000 + Math.random() * 900000);

            // console.log('verificationCode', verificationCode)

            await sendVerification(username, verificationCode)
            
            return verificationCode; 

        } else {

            setIsAuthenticated(false);
            return false;
        }
        
    };

    const autoauthenticate = async (userKey) => {

        let query = `SELECT * FROM users WHERE userKey = ?`
        let users = await getRecords(query, [ userKey ])

        users = unescapeArray(users);

        console.log('users', users)

        if (users.length > 0) {

            let user = users[0];

            setIsAuthenticated(true);
            setData(user)
            return true;

        } else {

            setIsAuthenticated(false);
            return false;
        }
        
    };

    // Authenticate user and set the isAuthenticated state to true

    const authenticate = async (username) => {

        console.log('authenticating user', username)
        
        let query = `SELECT users.*, clients.type FROM users LEFT JOIN clients ON users.clientKey = clients.clientKey WHERE users.email = ? AND clients.type = ?`
        let users = await getRecords(query, [ username, 'User' ])

        

        // users = unescapeArray(users);
        users = unescapeNested(users)

        if (users.length > 0) {

            let user = users[0];

            setIsAuthenticated(true);
            setData(user)
            return true;

        } else {

            setIsAuthenticated(false);
            return false;
        }
        
    };

    
    const logout = () => {

        localStorage.removeItem(`${SiteConfig.cookieName}-cluId`);

        setIsAuthenticated(false);
    };

    const checkAuth = () => {
        return isAuthenticated;
    };

    return (
        <GlobalContext.Provider value={{ masterMenu, setMasterMenu, title, setTitle, authenticate, autoauthenticate, logout, checkAuth, UserData, getCode}}>
            {children}
        </GlobalContext.Provider>
    );
};
